import EmblaSlider, { OffersCarousalSkeleton } from "@/components/EmblaSlider";
import OfferCard from "@/components/OfferCard";
import { dataLayerProductViewList } from "@/helpers/dataLayer";
import "@/styles/emblaShopSlider.css";
import { useTrendingItems } from "@/utils/hooks/useTrendingItems";
import { Box } from "@dxp-feed/ui/Box";
import { useEffect, useState } from "react";

interface SlideScrollProps {
  base: number;
  xsm: number;
  sm: number;
  ssm: number;
  md: number;
  lg: number;
  xl: number;
  xml: number;
  xxl: number;
}
export default function EmblaTrendingProductSlider({
  base,
  sm,
  ssm,
  md,
  lg,
  xl,
  xml,
  xxl,
}: {
  productIds?: string[];
  displayedFrom?: string;
  base?: number;
  xsm?: number;
  sm?: number;
  ssm?: number;
  md?: number;
  lg?: number;
  xl?: number;
  xml?: number;
  xxl?: number;
}) {
  const [productsData, setProductsData] = useState<any[]>([]);

  const { data: popularItems } = useTrendingItems(true);
  useEffect(() => {
    if (popularItems && popularItems?.products?.nbHits > 0) {
      setProductsData(popularItems?.products?.hits);
    }
  }, [popularItems]);

  const customSlidesToScroll: SlideScrollProps = {
    base: base ?? 1,
    xsm: base ?? 2,
    sm: sm ?? 2,
    ssm: ssm ?? 2.8,
    md: md ?? 4,
    lg: lg ?? 4,
    xl: xl ?? 5,
    xml: xml ?? 5,
    xxl: xxl ?? 5,
  };

  const [visibleItems, setVisibleItems] = useState<Set<string>>(new Set());
  const [pendingItems, setPendingItems] = useState<Set<string>>(new Set());
  const [isAllProductCapture, setIsAllProductCapture] = useState(false);
  const [lastSentItems, setLastSentItems] = useState<Set<string>>(new Set());

  const handleVisibilityChange = (item: any, isVisible: boolean) => {
    const itemString = JSON.stringify(item);

    if (isAllProductCapture) return;

    if (isVisible) {
      setVisibleItems((prev) => {
        const newVisible = new Set(prev);
        newVisible.add(itemString);
        return newVisible;
      });
      setPendingItems((prev) => {
        const newPending = new Set(prev);
        newPending.delete(itemString);
        return newPending;
      });
    } else {
      setPendingItems((prev) => {
        const newPending = new Set(prev);
        newPending.add(itemString);
        return newPending;
      });
      setVisibleItems((prev) => {
        const newVisible = new Set(prev);
        newVisible.delete(itemString);
        return newVisible;
      });
    }
  };

  useEffect(() => {
    if (isAllProductCapture || visibleItems.size === 0) return;
    const newItems = new Set(
      [...visibleItems].filter((x) => !lastSentItems.has(x))
    );
    if (newItems.size > 0) {
      const products = Array.from(newItems).map((item) => JSON.parse(item));
      dataLayerProductViewList({
        event: "view_item_list",
        ecommerce: {
          item_list_id: "1",
          item_list_name: "Homepage - Flyer Offers",
          items: products,
        },
      });
      setLastSentItems((prev) => new Set([...prev, ...newItems]));
    }
    if (visibleItems.size === productsData.length) {
      setIsAllProductCapture(true);
    }
  }, [visibleItems, isAllProductCapture, productsData.length, lastSentItems]);

  return (
    <Box as="div">
      {productsData?.length ? (
        <EmblaSlider
          align="center"
          options={{ loop: true, align: "start", dragFree: true }}
          slidesPerView={customSlidesToScroll}
          slidesToScroll={customSlidesToScroll}
          showControls={true}
          thumbnails={false}
          className="flyerofferlistSlider"
        >
          {productsData?.length > 0 &&
            productsData.map((products: any) => (
              <OfferCard
                key={products.articleNumber}
                item={products}
                onVisibilityChange={handleVisibilityChange}
                viewItemList={"Homepage - Flyer Offers"}
                viewItemListId={"1"}
              />
            ))}
        </EmblaSlider>
      ) : (
        <OffersCarousalSkeleton />
      )}
    </Box>
  );
}
